import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import CategoryDataService from "../../services/CategoryService";
import DropDownSelector from "../micro_components/DropDownSelector";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CustomTextModal from "../micro_components/CustomTextModal";

const AddGroupModal = ({ open, initialGroup, setLoading, setIsOpen, domains }) => {
  const [newGroup, setNewGroup] = useState(initialGroup);

  const handleGroupNameChange = (e) => {
    setNewGroup({ ...newGroup, name: e.target.value });
  };

  //upload new group
  const uploadNewGroup = () => {
    setLoading(true);
    console.log(newGroup);
    CategoryDataService.uploadNewGroup(newGroup)
      .then((response) => {
        console.log("uploaded new group: ", response.data);
        setLoading(false);
        setIsOpen(false);
        window.location.reload(false);
      })
      .catch((e) => {
        console.log("error uploading group: ", e);
        setLoading(false);
        setIsOpen(false);
      });
  };

  const handleGroupDomainSelect = (domain) => {
    setNewGroup({ ...newGroup, domain_id: parseInt(domain) });
  };

  const handleClose = () => {
    setNewGroup(initialGroup);
    setIsOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose} className="add-modal">
      <div className="add-modal-content">
        <h3>Add New Category Group</h3>
        <div className="add-name">
          <TextField style={{ width: 400 }} label="Name" variant="filled" fullWidth onChange={handleGroupNameChange} />
          <Button style={{ marginLeft: "15px" }} color="primary" onClick={uploadNewGroup}>
            Submit
          </Button>
          <Button style={{ marginRight: "-15px" }} color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </div>
        <div style={{ marginTop: "10px" }}>
          <DropDownSelector
            data={domains}
            placeholder={"Domain"}
            value={newGroup.domain_id}
            onChange={handleGroupDomainSelect}
          />
        </div>
      </div>
    </Modal>
  );
};

const AddCategoryModal = ({ isOpen, domains, initialCategory, setIsOpen, allGroups }) => {
  const [newCategory, setNewCategory] = useState(initialCategory);
  const [filterDomain, setFilterDomain] = useState(1);
  const [filteredGroups, setFilteredGroups] = useState([]);

  useEffect(() => {
    if (allGroups && allGroups.length > 0 && filterDomain) {
      setFilteredGroups(
        allGroups.filter((g) => {
          return g.domain_id === parseInt(filterDomain);
        })
      );
    }
  }, [allGroups, filterDomain]);

  const handleClose = () => {
    setIsOpen(false);
    setNewCategory(initialCategory);
  };

  const handleNameChange = (e) => {
    setNewCategory({ ...newCategory, name: e.target.value });
  };

  const selectGroup = (group) => {
    setNewCategory({ ...newCategory, group_id: parseInt(group) });
  };

  const upload = () => {
    // var formattedCategory = {
    //   name: newCategoryName,
    //   domain_id: newCategoryDomain,
    // };
    // console.log("uploading: ", formattedCategory);
    // console.log(newCategory);
    CategoryDataService.addNewCategory(newCategory)
      .then((response) => {
        console.log("success");
        window.location.reload(false);
        // setAddSuccess(true);
      })
      .catch((error) => console.log("error adding category: " + error));
    // console.log(newCategoryName);
  };

  const selectFilterDomain = (domain) => {
    setFilterDomain(parseInt(domain));
    setFilteredGroups(
      allGroups.filter((g) => {
        return g.domain_id === parseInt(domain);
      })
    );
  };

  //fix bug of changing domain and group not changing
  useEffect(() => {
    if (filteredGroups && filteredGroups.length > 0) {
      setNewCategory({ ...newCategory, group_id: filteredGroups[0].id });
    }
  }, [filteredGroups]);

  // useEffect(() => {
  //   console.log(newCategory);
  // }, [newCategory]);

  return (
    <Modal open={isOpen} onClose={handleClose} className="add-modal">
      <div className="add-modal-content">
        <h3>Add Category</h3>
        <div className="add-name">
          <TextField style={{ width: 400 }} label="Name" variant="filled" fullWidth onChange={handleNameChange} />
          <Button style={{ marginLeft: "15px" }} color="primary" onClick={upload}>
            Submit
          </Button>
          <Button style={{ marginRight: "-15px" }} color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",

            height: "100%",
            alignItems: "center",
          }}
        >
          <div style={{ marginRight: "1rem" }}>Domain: </div>
          <DropDownSelector data={domains} placeholder={"Domain"} value={filterDomain} onChange={selectFilterDomain} />
        </div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",

            height: "100%",
            alignItems: "center",
          }}
        >
          <div style={{ marginRight: "1rem" }}>Group: </div>
          <DropDownSelector
            data={filteredGroups}
            placeholder={"Group"}
            value={newCategory.group}
            onChange={selectGroup}
          />
        </div>
      </div>
    </Modal>
  );
};

//title, ordernum, group
const CategoryDetailsModal = ({ category, isOpen, onClose, setIsOpen, getAll, allGroups, domains }) => {
  const [localCategory, setLocalCategory] = useState({
    id: category.id,
    name: category.name,
    order_num: category.order_num,
    group_id: category.group.id,
  });

  const [filteredGroups, setFilteredGroups] = useState([]);

  const [selectedDomain, setSelectedDomain] = useState(category.group.domain_id);

  //save
  const submit = () => {
    CategoryDataService.updateCategory(localCategory.id, localCategory)
      .then((response) => {
        console.log(response.data);
        setIsOpen(false);
        getAll();
      })
      .catch((e) => console.log("error updating category: " + e));
  };

  //name change
  const handleNameChange = (e) => {
    setLocalCategory({ ...localCategory, name: e.target.value });
  };

  //order num change
  const handleOrderNumChange = (e) => {
    setLocalCategory({ ...localCategory, order_num: parseInt(e.target.value) });
  };

  //group id select
  const handleGroupSelect = (g) => {
    console.log("group_id: ", g);
    setLocalCategory({ ...localCategory, group_id: parseInt(g) });
  };

  //filter groups based on domain pick
  useEffect(() => {
    if (allGroups && allGroups.length && allGroups.length > 0) {
      setFilteredGroups(
        allGroups.filter((g) => {
          return g.domain_id === selectedDomain;
        })
      );
    }
  }, [allGroups, selectedDomain]);

  const handleDomainSelect = (e) => {
    let d = parseInt(e);
    let arr = allGroups.filter((g) => {
      return g.domain_id === d;
    });
    if (d !== selectedDomain) {
      handleGroupSelect(arr[0]?.id);
    }
    setSelectedDomain(d);
  };

  // useEffect(() => {
  // console.log("localCat: ", localCategory);

  // useEffect(() => {
  //   console.log("selectedDomain: ", selectedDomain);
  // }, [selectedDomain]);

  return (
    <CustomTextModal
      title={"Edit " + category.name}
      isOpen={isOpen}
      onClose={onClose}
      changeField={handleNameChange}
      onSubmit={submit}
      initial={category.name}
      extraContent={
        <>
          <TextField label="Order" variant="filled" onChange={handleOrderNumChange} defaultValue={category.order_num} />
          <DropDownSelector
            data={domains}
            placeholder={"Domain"}
            value={selectedDomain}
            onChange={handleDomainSelect}
          />
          <DropDownSelector
            data={filteredGroups}
            placeholder={"Group"}
            value={localCategory.group}
            onChange={handleGroupSelect}
          />
        </>
      }
    />
  );
};

export { AddCategoryModal, AddGroupModal, CategoryDetailsModal };
